/* AD-02 · ENTITLEMENTS
   ADM-03/04/05: grant/edit with reason, owner, dates; second-actor approval;
   effective versions + Stripe reconciliation + rollback. Entitlement is the
   source of truth (§61). */
import { Button, Card, KV, Note } from '@/ui'
import { useAdmin } from './AdminShell'

export default function AD02Entitlements() {
  const e = useAdmin().entitlement
  return (
    <section data-frame="AD-02" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Entitlement — accorder / modifier</h2>
      <Card>
        <KV rows={[
          ['Workspace', e.workspace],
          ['Changement', <>{e.changePlan} · <strong>{e.changeComped}</strong> · {e.changeWindow}</>],
          ['Motif', e.motif],
          ['Demandeur', <>{e.requester} · <strong>{e.secondActor}</strong> : {e.secondActorState}</>],
        ]} />
      </Card>
      <Note tone="candour">
        Diff avant/après + preuve obligatoire. Sans double validation, l’octroi reste bloqué.
        Historique versionné, alertes d’expiration, réconciliation Stripe, retour arrière possible.
      </Note>
      <div><Button variant="primary">Soumettre à approbation</Button></div>
    </section>
  )
}
